export const messages = {
  en: {
    todayAttendanceManage: {
      search: {
        title: 'Search Conditions',
        classesName: 'Please enter team name',
        departmentName: 'Please enter department name',
        date: 'Please select attendance date',
        staffName: 'Please enter staff name'
      },
      list: {
        title: 'Today Attendance'
      },
      table: {
        staffName: 'Staff Name',
        classesName: 'Attendance Team',
        attendanceDate: 'Attendance Date',
        stateName: 'Attendance Status',
        operation: 'Operation'
      },
      fetchError: 'Failed to fetch attendance data'
    },
    todayAttendanceDetail: {
      title: 'Attendance Details',
      table: {
        name: 'Name',
        work: 'Work',
        offWork: 'Off Work',
        attendanceRange: 'Attendance Range',
        lateEarly: 'Late/Early',
        status: 'Status',
        attendanceTime: 'Attendance Time',
        notCheckIn: 'Not Checked In',
        snapshot: 'Snapshot'
      }
    }
  },
  zh: {
    todayAttendanceManage: {
      search: {
        title: '查询条件',
        classesName: '请输入班组名称',
        departmentName: '请输入部门名称',
        date: '请选择打卡时间',
        staffName: '请输入员工名称'
      },
      list: {
        title: '今日考勤'
      },
      table: {
        staffName: '员工名称',
        classesName: '考勤班组',
        attendanceDate: '考勤时间',
        stateName: '考勤状态',
        operation: '操作'
      },
      fetchError: '获取考勤数据失败'
    },
    todayAttendanceDetail: {
      title: '考勤详情',
      table: {
        name: '名称',
        work: '上班',
        offWork: '下班',
        attendanceRange: '打卡范围',
        lateEarly: '迟到/早退',
        status: '状态',
        attendanceTime: '打卡时间',
        notCheckIn: '未打卡',
snapshot: '抓拍'
    }
  },
  'zh-TW': {
    todayAttendanceManage: {
      search: {
        title: '查詢條件',
        classesName: '請輸入班組名稱',
        departmentName: '請輸入部門名稱',
        date: '請選擇打卡時間',
        staffName: '請輸入員工名稱'
      },
      list: {
        title: '今日考勤'
      },
      table: {
        staffName: '員工名稱',
        classesName: '考勤班組',
        attendanceDate: '考勤時間',
        stateName: '考勤狀態',
        operation: '操作'
      },
      fetchError: '獲取考勤數據失敗'
    },
    todayAttendanceDetail: {
      title: '考勤詳情',
      table: {
        name: '名稱',
        work: '上班',
        offWork: '下班',
        attendanceRange: '打卡範圍',
        lateEarly: '迟到/早退',
        status: '狀態',
        attendanceTime: '打卡時間',
        notCheckIn: '未打卡',
        snapshot: '抓拍'
      }
    }
  }
}
}